/* eslint-disable camelcase */
import React from 'react';
import i18n from 'i18next';

import {
  Tabs,
  Video,
  MarkdownRenderer,
  WorkoutExercisesList,
} from 'web-components';

import {
  Flex,
  H200,
  WorkoutExercisesView,
} from 'web-styled';

import AdditionalWorkout from './AdditionalWorkout';

type Props = {
  workout: any,
  activeTab: string,
  hasAdditional: boolean,
  setTab: { (): void },
};

const PersonalWorkout = ({
  workout,
  hasAdditional,
  activeTab,
  setTab,
}: Props) => (
  <Flex
    column
    width="100%"
    padding="10px 20px"
    spacing={20}
  >
    <Tabs
      size="large"
      active={activeTab}
      onRequestChange={tab => setTab(tab)}
    >
      <Flex
        column
        width="100%"
        label={i18n.t('Workout')}
        value="workout"
        padding="20px 0"
        spacing={30}
      >
        <Flex width="100%">
          <Flex
            column
            width="30%"
            style={{
              minWidth: '400px',
            }}
          >
            <Video
              src={workout.video_url}
              readOnly
              height="250px"
              resourceType="workoutTemplates"
            />
          </Flex>
          <Flex
            column
            spacing={15}
            padding="0 15px"
          >
            <H200 color="primary">{workout.name}</H200>

            <MarkdownRenderer
              source={workout?.description}
              placeholder="A description has not been assigned yet."
            />
          </Flex>
        </Flex>
        <WorkoutExercisesView>
          <WorkoutExercisesList
            type="workout"
            readOnly
            workoutId={workout.id}
          />
        </WorkoutExercisesView>
      </Flex>
      {hasAdditional && (
        <AdditionalWorkout
          label="Warmup"
          value="warmup"
          id={workout.warmup_id}
          resourceType="warmups"
        />
      )}
      {hasAdditional && (
        <AdditionalWorkout
          label="Cooldown"
          value="cooldown"
          id={workout.cooldown_id}
          resourceType="cooldowns"
        />
      )}
    </Tabs>
  </Flex>
);

export default PersonalWorkout;
